import { Box, Button } from '@mui/material';
import React from 'react';
import './SelectAllButton.scss';

interface IProps {
  onClick: () => void;
  text: string;
}

const SelectAllButton: React.FunctionComponent<IProps> = ({ onClick, text }: IProps) => {
  return (
    <Box className="button-container">
      <Button className="button-container__button-width" onClick={onClick}>
        {'All'}
      </Button>
      <span className="section-header-info-text">{text}</span>
    </Box>
  );
};

export default SelectAllButton;
